<template>
    <div v-if="imageUrl === undefined" class="w-full h-full flex items-center justify-center">
        <el-icon class="is-loading">
            <Loading />
        </el-icon>
    </div>
    <img v-else-if="imageUrl" :src="imageUrl" />
</template>

<script lang="ts">
import axios from 'axios';
import { ref, onMounted, defineComponent, watch } from 'vue';
import { Loading} from '@element-plus/icons-vue';
import { ResponseStatus } from './response';
import { ElMessage } from 'element-plus';

export default defineComponent({
    name: 'ImgLoading',
    components: {
        Loading,
    },
    props:{
        modelValue: {
            type: String,
            default: ''
        },
    },
    setup(props) {
        const imageUrl = ref<string | undefined>(undefined);

        onMounted(async () => {
            if(!props.modelValue) {
                imageUrl.value = '';
                return;
            }


            imageUrl.value = await getImage(props.modelValue);
        });

        watch(() => props.modelValue, async (newValue) => {
            imageUrl.value = undefined;
            
            if(!newValue) {
                imageUrl.value = '';
                return;
            }

            imageUrl.value = await getImage(newValue);
        });

        const getImage = async (imageId: string) => {
            var imgUrl = '';
            const res = await axios.get(`/api/images/download/${imageId}`, { responseType: 'blob' });
            if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                // 预览(单张 本画面特定)
                imgUrl = URL.createObjectURL(res.data);
            } else {
                ElMessage.error('画像情報の取得に失敗しました。');
            }

            return imgUrl;
        };
        
        return {
            imageUrl,
        };
    }
});
</script>